import { Badge } from 'src/design/atoms/Badge';
import { Select } from 'src/design/atoms/Select';
import React from 'react';
import { resolveWorkflowButtonColor } from 'src/utils';

export type IntentType = 'primary' | 'success' | 'warning' | 'danger' | 'none';

export interface IUserSelectProps {
  onChange: (value: IntentType) => void;
  value: IntentType;
  text?: string;
  hideLabel?: boolean;
}

export interface IColorOption {
  value: IntentType;
  label: string;
}

const OPTIONS: IColorOption[] = [
  {
    value: 'primary',
    label: 'primary',
  },
  {
    value: 'success',
    label: 'success',
  },
  {
    value: 'warning',
    label: 'warning',
  },
  {
    value: 'danger',
    label: 'danger',
  },
  {
    value: 'none',
    label: 'none',
  },
];

/** @registry Select dropdown of theme colors for tagging/labeling records. */
export const ColorSelect: React.FC<IUserSelectProps> = ({
  onChange,
  text = '',
  value,
  hideLabel = false,
}) => {
  const data = React.useMemo(() => {
    return OPTIONS.map((option) => ({
      value: option.value,
      label:
        option.label.slice(0, 1).toUpperCase() + option.label.slice(1) ||
        option.value.slice(0, 1).toUpperCase() + option.value.slice(1),
    }));
  }, []);

  const handleChange = (selectedValue: string | null) => {
    if (selectedValue) {
      onChange(selectedValue as IntentType);
    }
  };

  // Custom option rendering to show color swatches with Mantine Badge
  const renderOption = ({
    option,
  }: {
    option: { value: string; label: string };
  }) => {
    const color = resolveWorkflowButtonColor(option.value) || 'gray';
    const variant = option.value !== 'none' ? 'filled' : 'light';
    return (
      <>
        <Badge color={color} variant={variant} style={{ width: '100%' }}>
          {text}
        </Badge>
      </>
    );
  };

  const selectedColor = resolveWorkflowButtonColor(value) || 'gray';
  const selectedVariant = value !== 'none' ? 'filled' : 'light';

  return (
    <Select
      label={!hideLabel ? 'Button Color' : undefined}
      placeholder="Select a color..."
      data={data}
      value={value}
      onChange={handleChange}
      leftSection={
        !value ? undefined : (
          <div style={{ marginTop: 5 }}>
            <Badge color={selectedColor} variant={selectedVariant}>
              {text}
            </Badge>
          </div>
        )
      }
      renderOption={renderOption}
      styles={{
        input: { color: 'transparent' },
      }}
    />
  );
};
